import moment from "moment";
import CountDownButton from "../../framework/util/uicomps/buttons/CountDownButton";
import SimpleList from "../../framework/util/uicomps/lists/SimpleList";
import React from "react";

const formatPrimary = (job) => {
    return job.name;
}
const formatSecondary = (job) => {
    const ts = moment(job.printingEnd).fromNow();//.format(formatstr);
    const spreads = job.spreads;
    const sortRuleGroup = job["Sort Rule Group"]

    return ts + ', ' + sortRuleGroup + ', ' + spreads + ' spreads ';
}

const SimplePressJobsList = ({jobs, maxHeight})=> {
    return (<SimpleList rows={jobs} maxHeight={maxHeight}
                getPrimaryFunc={formatPrimary} getSecondaryFunc={formatSecondary}/>);
}

export default SimplePressJobsList;